import { useEffect, useState } from "react";
import { groupdetails } from "../../components/funtionsBD/Mainservice";
import { useLocation } from "react-router-dom";
import AdminLayout from "../../components/AdminLayout";
import "./Groupdetails.css";

export const Groupdetails = () => {
  const [data, setdata] = useState([]);
  const location = useLocation();
  const id = location.state.id;

  useEffect(() => {
    getdetails(id);
  }, [id]);

  const getdetails = async () => {
    try {
      const response = await groupdetails(id);
      setdata(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <AdminLayout>
      <div className="title">
        <h1>Group Details</h1>
      </div>

      <div className="groupdetails">
        <p>
          Group Name :<span>{data.gr_name}</span>
        </p>
        <p>
          Group Description :<span> {data.gr_des}</span>
        </p>
        <p>
          Training content :<span>{data.tbl_gen_mode_t?.ts_gen_mode}</span>
        </p>
        <p>
          Create At : <span>{data?.createdAt?.split("T")[0]}</span>
        </p>
        <p>
          Player list :
          {data?.tbl_players?.map((i, index) => (
            <div className="groupmember" key={index}>
              {i.tbl_user.user_image ? (
                <img src={i.tbl_user.user_image} />
              ) : (
                <div className="groupmemberprofile">
                  {" "}
                  {i.tbl_user.user_alias
                    ? i.tbl_user.user_alias.slice(0, 1)
                    : i.tbl_user.user_first_name.slice(0, 1)}
                </div>
              )}
              {i.tbl_user.user_alias
                ? i.tbl_user.user_alias
                : i.tbl_user.user_first_name}
            </div>
          ))}
        </p>
        <p>
          Coach list :
          {data?.tbl_coaches?.map((i, index) => (
            <div className="groupmember" key={index}>
              {i.tbl_user.user_image ? (
                <img src={i.tbl_user.user_image} />
              ) : (
                <div className="groupmemberprofile">
                  {" "}
                  {i.tbl_user.user_alias
                    ? i.tbl_user.user_alias.slice(0, 1)
                    : i.tbl_user.user_first_name.slice(0, 1)}
                </div>
              )}
              {i.tbl_user.user_alias
                ? i.tbl_user.user_alias
                : i.tbl_user.user_first_name}
            </div>
          ))}
        </p>
      </div>
    </AdminLayout>
  );
};
